import { createEntityAdapter } from '@reduxjs/toolkit';

const countriesAdapter = createEntityAdapter();

export default countriesAdapter;
